/* mainProduct — Alpine.js component for the StickyGolf custom PDP section.
   Registered as a global function so x-data="mainProduct({...})" works. */
window.mainProduct = function (opts) {
  return {
    product: opts.product,
    selectedVariant: opts.selectedVariant,

    // Accordion
    activeAccordion: null,

    // Fullscreen image modal
    visibleSliderModal: false,

    // UGC video block state (inherited by child blocks via Alpine scope)
    currentVideoId: null,
    stopAllVideo() {
      this.$el.querySelectorAll('deferred-media video').forEach(function(v) {
        v.pause();
        v.currentTime = 0;
      });
    },

    // Internal Swiper refs
    _thumbSwiper: null,
    _mainSwiper: null,
    _modalMainSwiper: null,
    _modalThumbSwiper: null,

    init() {
      var self = this;
      function tryInit(attempt) {
        if (attempt > 120) return;
        if (!window.Swiper) {
          requestAnimationFrame(function () { tryInit(attempt + 1); });
          return;
        }
        self._initGallery();
      }
      // Defer until after Alpine + Swiper deferred scripts have evaluated
      if (document.readyState === 'complete') {
        tryInit(0);
      } else {
        window.addEventListener('load', function () { tryInit(0); });
      }
    },

    _initGallery() {
      var root = this.$el;

      // --- Thumbnail strip (vertical, left side, desktop) ---
      var thumbEl = this.$refs && this.$refs.thumbnailSlider;
      if (thumbEl && !thumbEl.swiper) {
        this._thumbSwiper = new window.Swiper(thumbEl, {
          direction: 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: true,
          watchSlidesProgress: true,
          navigation: {
            prevEl: root.querySelector('.swiper-product-button-prev-thumb'),
            nextEl: root.querySelector('.swiper-product-button-next-thumb'),
          },
        });
      }

      // --- Main image slider (second .swiper inside .mainProduct__slider) ---
      var sliderWrap = root.querySelector('.mainProduct__slider');
      if (!sliderWrap) return;
      var mainEl = null;
      sliderWrap.querySelectorAll('.swiper').forEach(function (el) {
        if (!el.swiper && el !== thumbEl) mainEl = el;
      });

      if (mainEl && !mainEl.swiper) {
        // slidesPerView:1 keeps each slide square (matches the 1:1 carousel
        // container). Peek is already handled by the existing
        // .swiper[x-ref="mainSlider"] width:90% + overflow:visible CSS —
        // don't double up with a decimal slidesPerView (causes slide-2 to
        // render at a different width than slide-1).
        var cfg = {
          slidesPerView: 1,
          spaceBetween: 3,
          loop: true,
          navigation: {
            prevEl: sliderWrap.querySelector('.swiper-product-button-prev:not(.swiper-product-button-prev-thumb)'),
            nextEl: sliderWrap.querySelector('.swiper-product-button-next:not(.swiper-product-button-next-thumb)'),
          },
          pagination: {
            el: sliderWrap.querySelector('.swiper-pagination'),
            clickable: true,
          },
        };
        if (this._thumbSwiper) {
          cfg.thumbs = { swiper: this._thumbSwiper };
        }
        this._mainSwiper = new window.Swiper(mainEl, cfg);
      }
    },

    showSliderModal(startIndex) {
      this.visibleSliderModal = true;
      var self = this;
      this.$nextTick(function () {
        self._initModalSwipers(startIndex || 0);
      });
    },

    hideSliderModal() {
      this.visibleSliderModal = false;
    },

    _initModalSwipers(startIndex) {
      if (this._modalMainSwiper) {
        this._modalMainSwiper.slideTo(startIndex);
        return;
      }

      var thumbEl = this.$refs && this.$refs.thumbnailSliderModal;
      if (thumbEl && !thumbEl.swiper) {
        this._modalThumbSwiper = new window.Swiper(thumbEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
          centeredSlides: true,
        });
      }

      var mainEl = this.$refs && this.$refs.mainSliderModal;
      if (mainEl && !mainEl.swiper) {
        var cfg = {
          initialSlide: startIndex,
          slidesPerView: 1,
          spaceBetween: 0,
        };
        if (this._modalThumbSwiper) {
          cfg.thumbs = { swiper: this._modalThumbSwiper };
        }
        this._modalMainSwiper = new window.Swiper(mainEl, cfg);

        if (this._modalThumbSwiper && this._modalMainSwiper) {
          this._modalThumbSwiper.update();
        }
      }
    },

    playVideo() {
      var video = this.$el.querySelector('.visibleSliderModal video, .tw-fixed video');
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    },
  };
};

/* Global handler for the upsell toggle checkboxes on the PDP.
   Called via Alpine @change="toggleGolfClub($el)" in mp-additional-product.liquid. */
window.toggleGolfClub = function(checkbox) {
  var variantId = parseInt(checkbox.dataset.additionalProductId, 10);
  if (!variantId) return;

  var checked = checkbox.checked;
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, '/');

  // NOTE: sections param intentionally omitted. In the dev theme, requesting
  // section re-renders inline with cart/add.js was either 401-ing the request
  // (multi-item shape with stale section IDs) or returning success but with
  // sections data missing requested keys (breaks Horizon's section-renderer).
  // Cart UI updates rely on the cart:update event + follow-up cart.js fetch.
  var sectionsParam = '';

  function dispatchUpdate(cart, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'toggle-upsell',
        data: { source: 'toggle-upsell', itemCount: (cart && cart.item_count) || 0, sections: sections || null }
      }
    }));
  }

  if (checked) {
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionsParam) { body.sections = sectionsParam; body.sections_url = window.location.pathname; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      return fetch(root + 'cart.js').then(function(r) {
        return r.json().then(function(cart) { return { cart: cart, sections: data.sections || null }; });
      });
    })
    .then(function(result) {
      dispatchUpdate(result.cart, result.sections);
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
    })
    .catch(function(e) {
      console.error('[toggleGolfClub] add failed:', e);
      checkbox.checked = false;
    });
  } else {
    fetch(root + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var item = cart.items.find(function(i) { return i.variant_id === variantId; });
      if (!item) { dispatchUpdate(cart, null); return; }

      var body = { id: item.key, quantity: 0 };
      if (sectionsParam) { body.sections = sectionsParam; body.sections_url = window.location.pathname; }

      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.json(); })
      .then(function(updated) { dispatchUpdate(updated, updated.sections || null); });
    })
    .catch(function(e) {
      console.error('[toggleGolfClub] remove failed:', e);
      checkbox.checked = true;
    });
  }
};
